// Errors and a sample of page-load and navigation traces go to Sentry when the build has
// VITE_SENTRY_DSN (a Dokploy build argument); without it nothing is sent. The player-facing
// pages load this module before their entry module, so errors while a page starts are caught.
// Production source maps are public (build.sourcemap), so Sentry reads stack traces from them.
import * as Sentry from '@sentry/browser'

const env = import.meta.env || {}
if (env.VITE_SENTRY_DSN) Sentry.init({
  dsn: env.VITE_SENTRY_DSN,
  environment: env.VITE_SENTRY_ENVIRONMENT || env.MODE,
  release: env.VITE_SENTRY_RELEASE || undefined, // mew-game@<commit>, set by the Dockerfile
  integrations: [Sentry.browserTracingIntegration()],
  tracesSampleRate: Number(env.VITE_SENTRY_TRACES_SAMPLE_RATE || 0.1),
})
